import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { makeStyles } from '@material-ui/core/styles';
import { baseMenuPaperStyles, menuStyles } from '../Menu/Menu.styles';
export const useSplitButtonStyles = makeStyles((theme)=>({
        buttonGroup: {
            '& .MuiButtonGroup-groupedContainedHorizontal:not(:last-child)': {
                borderRight: '0px'
            },
            '& .MuiButtonGroup-groupedContainedHorizontal:focus-within': {
                boxShadow: 'none'
            },
            borderRadius: 8
        },
        toggleBtn: {
            padding: 0,
            minWidth: 32
        },
        popperZIndex: {
            zIndex: theme.zIndex.modal
        },
        paper: (param)=>{
            let { flushBottom } = param;
            return _object_spread({}, baseMenuPaperStyles, flushBottom && {
                overflow: 'hidden'
            });
        },
        menuList: (param)=>{
            let { flushBottom } = param;
            return _object_spread({}, menuStyles, flushBottom && {
                paddingBottom: 0
            });
        }
    }));
